import { CheckoutStatus as a } from "@ancon/wildcat-types";
function e(t) {
  const s = t == null ? void 0 : t.status;
  return s === a.Created || s === a.Ready || s === a.Processing;
}
export {
  e as default
};
